import { NazorgOverview } from '../translations-types';

const translations: NazorgOverview = {
  title: 'Aftercare overview',
  voorzorg: 'Before care',
  nazorg: 'After care',
  matching: 'Appointment matching',
  salonizedAppointments: 'Agenda',
  noResults: 'No completed questionnaires yet.',
  sent: 'Sent',
  notSent: 'Not sent',
  sentNotCompleted: 'Sent, not completed yet.',
  careNoAppointments: 'No matched appointments.',
  viewResults: 'View results',
  sendAction: 'Send',
  sendConfirm: 'The questionnaire will be (re)sent to the customer by email.',
  sendSuccess: 'Questionnaire sent.',
};

export default translations;
